// Tiny WebAudio engine for short UI cues, plus a real low-volume looping
// office ambience recording (soft chatter, keyboards, phones) played through a
// hidden <audio> element so it sounds like an actual working floor.

let ctx;
function ac() {
  if (!ctx) {
    const C = window.AudioContext || window.webkitAudioContext;
    if (C) ctx = new C();
  }
  return ctx;
}

// Call after a user gesture (e.g. toggling sound on) so the browser allows audio.
export function unlockAudio() {
  const c = ac();
  if (c && c.state === "suspended") c.resume();
}

// type: "start" (an office lights up) | "complete" (a task finishes)
export function playCue(type) {
  const c = ac();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const now = c.currentTime;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = "sine";
  o.connect(g);
  g.connect(c.destination);
  if (type === "start") {
    o.frequency.setValueAtTime(520, now);
    o.frequency.exponentialRampToValueAtTime(784, now + 0.12);
  } else {
    o.frequency.setValueAtTime(740, now);
    o.frequency.exponentialRampToValueAtTime(440, now + 0.2);
  }
  g.gain.setValueAtTime(0.0001, now);
  g.gain.exponentialRampToValueAtTime(0.04, now + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, now + 0.3);
  o.start(now);
  o.stop(now + 0.32);
}

// ---------------------------------------------------------------------------
// Ambient office soundscape — a real recording (keyboards, phones, soft
// chatter) looped quietly in the background while "Sounds" is on.
// ---------------------------------------------------------------------------
const AMBIENCE_SRC = "/sounds/office-ambience.mp3";
let ambienceVolume = 0.18; // low, non-distracting default
try {
  const stored = parseFloat(localStorage.getItem("iq-floor-volume"));
  if (!Number.isNaN(stored)) ambienceVolume = Math.min(1, Math.max(0, stored));
} catch (_) {}
let ambienceEl = null;
let fadeTimer = null;

export function getAmbienceVolume() {
  return ambienceVolume;
}

// Live volume control for the ambience slider (0..1).
export function setAmbienceVolume(v) {
  ambienceVolume = Math.min(1, Math.max(0, v));
  try { localStorage.setItem("iq-floor-volume", String(ambienceVolume)); } catch (_) {}
  if (ambienceEl && !ambienceEl.paused) {
    clearInterval(fadeTimer);
    ambienceEl.volume = ambienceVolume;
  }
}

export function startAmbience() {
  unlockAudio();
  if (!ambienceEl) {
    ambienceEl = new Audio(AMBIENCE_SRC);
    ambienceEl.loop = true;
    ambienceEl.preload = "auto";
    ambienceEl.volume = 0;
  }
  clearInterval(fadeTimer);
  const el = ambienceEl;
  const p = el.play();
  if (p && p.catch) p.catch(() => {});
  // gentle fade-in to the current target volume
  let v = el.volume;
  fadeTimer = setInterval(() => {
    v = Math.min(ambienceVolume, v + 0.02);
    el.volume = v;
    if (v >= ambienceVolume) clearInterval(fadeTimer);
  }, 60);
}

export function stopAmbience() {
  if (!ambienceEl) return;
  const el = ambienceEl;
  clearInterval(fadeTimer);
  let v = el.volume;
  fadeTimer = setInterval(() => {
    v = Math.max(0, v - 0.03);
    el.volume = v;
    if (v <= 0) {
      clearInterval(fadeTimer);
      try { el.pause(); el.currentTime = 0; } catch (_) {}
    }
  }, 50);
}
